import isEmpty from 'lodash/isEmpty';
import { useRouter } from 'next/router';
import { ReactElement } from 'react';

import { Calculations, Gamepad, QnA, Review } from '@sravni/react-icons';

import { Rocket } from '../components/Icons/Roket';
import { LIST, LIST_BY_RUBRICS, LIST_BY_TAGS, SPECIAL_PROJECTS } from '../constants/routes';
import { TRubricType } from '../interfaces/news';
import { IFormats } from '../interfaces/sideMenu';
import { createLinkProps } from '../utils/routing';

export interface IMenuFormat {
  name: string;
  icon: ReactElement;
  url?: string;
  link?: {
    href: string;
    as: string;
  };
  isExternal?: boolean;
  isActive: boolean;
  isVisible: boolean;
}

export const useFormats = (): IMenuFormat[] => {
  const { asPath, query } = useRouter();

  const listLink = () => createLinkProps('list', LIST);

  const listRubricLink = (value: TRubricType) =>
    createLinkProps('list', LIST_BY_RUBRICS, {
      rubric: value,
    });

  const listTagLink = (value: string) =>
    createLinkProps('list', LIST_BY_TAGS, {
      tag: value,
    });

  const specialProjectsLink = (value: string) =>
    createLinkProps('specialProjects', SPECIAL_PROJECTS, {
      project: value,
    });

  const { rubric, rubricAlias, tag, project } = query;
  const formats: IFormats[] = [
    {
      name: 'Главное',
      icon: <Calculations />,
      link: listLink(),
      isActive:
        (isEmpty(query) && !asPath.includes('/search')) ||
        (rubric && !['novosti-partnerov', 'novosti'].includes(rubric as string)) ||
        (rubricAlias && ['novosti'].includes(rubricAlias as string)) ||
        (tag && tag !== 'partnerskij-material' && tag !== 'testy-i-igry'),
      isVisible: true,
    },
    {
      name: 'Новости',
      icon: <Review />,
      link: listRubricLink('novosti'),
      isActive: rubric === 'novosti' || rubricAlias === 'novosti',
      isVisible: false,
    },
    {
      name: 'Вопрос эксперту',
      icon: <QnA />,
      url: '/q/',
      isExternal: true,
      isActive: false,
      isVisible: true,
    },
    {
      name: 'Тесты и игры',
      icon: <Gamepad />,
      link: listTagLink('testy-i-igry'),
      isActive: tag === 'testy-i-igry',
      isVisible: true,
    },
    {
      name: 'Спецпроекты',
      icon: <Rocket />,
      link: specialProjectsLink('special-projects'),
      isActive: project === 'special-projects',
      isVisible: true,
    },
    // {
    //   name: 'Блоги компаний',
    //   icon: <Subscriptions />,
    //   link: listRubricLink('novosti-partnerov'),
    //   isActive: rubric === 'novosti-partnerov' || rubricAlias === 'novosti-partnerov',
    //   isVisible: true,
    // },
  ];

  return formats;
};
